<div class="modal-header container-fluid">
    <h4 class="modal-title header-2"> Save As New Version </h4>
      <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
      />
    </button>
  </div>
  
  <div class="modal-body container-fluid">
    <div class="info-section">
      <span class="italic-general-text">
      A new version number
      </span>
      <span class="italic-general-text highlighted-text"> {{configs.version}} </span>
      <span class="italic-general-text">
       will be assigned automatically upon saving.
      </span>
    </div>
    <div>
        <app-dynamic-form [form]="dynamicForm" [formFields]="fields"></app-dynamic-form>
    </div>
  </div>
  
  <div class="modal-footer d-flex justify-content-end">
    <button class="btn  btn-accello-secondary mx-2" (click)="activeModal.dismiss('Cross click')"> Cancel </button>
    <button
      type="submit"
      class="btn  btn-accello-primary-light d-block"
      (click)="save()"
    >
      Save
    </button>
  </div>
  